import ThreadsContainer from "../../PremiumFinanceThreads/ThreadsContainer";

function ThreadsIntRev() {
  return (
    <div>
      <ThreadsContainer proposalId="863f01ec-1627-4665-aaf8-fcb8d5e0375b" isPlan threadType="" />
    </div>
  );
}
export default ThreadsIntRev;
